import { format } from 'date-fns';

/**
 * @returns the timezone offset in the format: '+11:00', '-02:00' https://date-fns.org/v2.29.2/docs/format
 */
export const getTimezoneOffset = (date = new Date()): string => {
  return format(date, 'xxx');
};
